import { useContext } from 'react'
import { useTranslation } from "react-i18next";
import { AppState } from 'App';

import PostOptions from 'components/ui/post/PostOptions'
import PhotoGrid2 from 'components/ui/post/PhotoGrid2'
import Like from 'components/ui/Like'

const Post2 = ({ tag, post, photos, date, id, city, town, temperature, weather, icon, liked, hidden, icons, order }) => {

    const [appState, setAppState] = useContext(AppState)
    const {t, i18n} = useTranslation('common');

    return (
        <>
        <div key={id} className="flex flex-col p-4 space-y-4 border rounded-lg 2xl:p-8 2xl:space-y-8 bg-itemlight dark:bg-itemdark w-160 2xl:w-190 border-borderlight dark:border-borderdark">
            <div className="flex flex-row justify-between h-12">
                <div className="flex flex-row items-center space-x-4">
                    <div className="flex items-center justify-center w-12 h-12 border rounded-full border-borderlight dark:border-borderdark">
                        {icons!==null && icons!==undefined && (`${tag}` in icons) ?
                        <span className="px-4 text-2xl">{icons[tag]}</span>
                        :
                        <span className="px-4">➕</span>
                        }
                    </div>
                    <div className="flex flex-row items-center">
                        <p className="text-sm font-light text-textlight dark:text-textdark">
                            {t('postdesc1')}&nbsp;
                            <button
                                onClick={() => setAppState(prevState => ({...prevState,tagContext:tag}))}
                                className="focus:outline-none">
                                    {tag} {t('postdesc2')}
                            </button> {t('postdesc3')} {date} {t('postdesc4')} {town}, {city}, {temperature} {t('postdesc5')}, {weather}
                            {/* <img src={`http://openweathermap.org/img/wn/${icon}@2x.png`} className="inline-block h-6" alt="weather icon"/> */}
                        </p>
                    </div>
                </div>
                <div className="flex flex-row items-center justify-center space-x-4">
                    <div id={`tour${order}`}>
                        <Like id={id} liked={liked}/>
                    </div>
                    <div  id={`toured${order}`} className="text-textdark">
                        <PostOptions id={id}/>
                    </div>
                </div>
            </div>
            <p className="text-textlightfeature dark:text-textdarkfeature">{post}</p>
            <PhotoGrid2 photos={photos} order={order}/>
        </div>
        </>
    )
}

export default Post2
